import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { LegalInvestigationsDebarredModel } from './types';
import { legalInvestigationsDebarredItemValidator } from './validators/item';

const legalInvestigationsDebarredValidator: ValidateJSModel<LegalInvestigationsDebarredModel> = {
  HasDebarment: { presence: true, hasValue: { validator: hasYesOrNo } },
  List: (value, attributes) => {
    if (attributes?.HasDebarment && attributes?.HasDebarment.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalInvestigationsDebarredItemValidator },
      };
    }
    return {};
  },
};
export default legalInvestigationsDebarredValidator;
